import React from 'react';
import { Button, Modal } from '@efast_public/fjd-component-library';

export interface ConfirmationModalProps {
  confirmationButtonLabel: string;
  abortButtonLabel: string;
  confirmationHeading: string;
  onConfirm: () => void;
  onAbort: () => void;
  isConfirmationModalVisible: boolean;
  'data-testid'?: string;
  content?: React.ReactNode;
}

export function ConfirmationModal({
  confirmationHeading,
  confirmationButtonLabel,
  abortButtonLabel,
  onConfirm,
  onAbort,
  isConfirmationModalVisible,
  'data-testid': dataTestId,
  content
}: ConfirmationModalProps) {
  return (
    <Modal
      open={isConfirmationModalVisible}
      onClose={onAbort}
      data-testid={dataTestId}
    >
      <Modal.Header id="modal-editUserRoles-header">
        {confirmationHeading}
      </Modal.Header>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Footer>
        <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
          <Button
            data-testid="cancel-button-inModalEditUserRoles"
            size="md"
            variant="primary-text"
            onClick={onAbort}
            style={{ flex: 1 }}
          >
            {abortButtonLabel}
          </Button>
          <Button
            data-testid="save-button-inModalEditUserRoles"
            size="md"
            variant="primary"
            onClick={onConfirm}
            style={{ flex: 1 }}
          >
            {confirmationButtonLabel}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
